export default {
  evachill: ['evaCHILL Cartridge'],
  evalight: ['evaLIGHT plus Cartridge', 'evaLIGHT Cartridge'],
  evasmart: ['evaSMART Cartridge'],
  accessories: ['evaAROMA set', 'evaBAG', 'evaBOTTLE', 'evaBANK'],
};
